import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, renderSlot as _renderSlot, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2687894f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { class: "title" }
const _hoisted_6 = { style: {"font-size":"15px","color":"#777","font-weight":"300"} }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_10 = {
  key: 3,
  class: "download"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_12 = { style: {"background":"#ececec"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InfoCircleOutlined = _resolveComponent("InfoCircleOutlined")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_a_breadcrumb = _resolveComponent("a-breadcrumb")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_PlusOutlined = _resolveComponent("PlusOutlined")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_upload_outlined = _resolveComponent("upload-outlined")!
  const _component_a_upload = _resolveComponent("a-upload")!
  const _component_a_card = _resolveComponent("a-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.title === 'WER Reports')
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("h1", _hoisted_3, _toDisplayString(_ctx.title), 1)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("h1", _hoisted_5, [
            _createTextVNode(_toDisplayString(_ctx.title), 1),
            _createElementVNode("small", _hoisted_6, "All created & archived " + _toDisplayString(_ctx.subTitle), 1)
          ])
        ])),
    (_ctx.breadcrumb == true)
      ? (_openBlock(), _createBlock(_component_a_row, {
          key: 2,
          class: "breadcrumb"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_breadcrumb, {
              separator: ">",
              routes: _ctx.routes
            }, {
              itemRender: _withCtx(({ route, routes }) => [
                (routes.indexOf(route) === 0)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_7, [
                      _createVNode(_component_InfoCircleOutlined),
                      _createTextVNode("   ")
                    ]))
                  : _createCommentVNode("", true),
                (routes.indexOf(route) === routes.length - 1)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(route.breadcrumbName), 1))
                  : (_openBlock(), _createBlock(_component_router_link, {
                      key: 2,
                      to: route.path
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(route.breadcrumbName), 1)
                      ]),
                      _: 2
                    }, 1032, ["to"]))
              ]),
              _: 1
            }, 8, ["routes"])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _hoisted_9,
    (_ctx.downloadButton == true)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _createVNode(_component_a_button, {
            class: "button-download",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('download')))
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Download Reports ")
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_a_row, null, {
      default: _withCtx(() => [
        (_ctx.addNewButton == true)
          ? (_openBlock(), _createBlock(_component_a_col, { key: 0 }, {
              default: _withCtx(() => [
                _createVNode(_component_a_button, {
                  class: "button-create",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('create')))
                }, {
                  icon: _withCtx(() => [
                    _createVNode(_component_PlusOutlined)
                  ]),
                  default: _withCtx(() => [
                    _createTextVNode("Add " + _toDisplayString(_ctx.title), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_ctx.downloadOutageLogs == true)
          ? (_openBlock(), _createBlock(_component_a_col, {
              key: 1,
              style: {"margin-left":"10px"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_button, {
                  class: "button-download",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('downloadOutageLogs')))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Download Outage Logs ")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_ctx.uploadDmzOutages == true)
          ? (_openBlock(), _createBlock(_component_a_col, {
              key: 2,
              style: {"margin-left":"10px"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_upload, {
                  "file-list": _ctx.fileList,
                  "onUpdate:file-list": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.fileList) = $event)),
                  name: "file",
                  multiple: true,
                  action: _ctx.upload_url,
                  headers: _ctx.headers,
                  onChange: _ctx.handleChange
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_button, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_upload_outlined),
                        _createTextVNode(" Click to Upload ")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["file-list", "action", "headers", "onChange"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _hoisted_11,
    _createElementVNode("div", _hoisted_12, [
      _createVNode(_component_a_card, { bordered: false }, {
        default: _withCtx(() => [
          _renderSlot(_ctx.$slots, "default", {}, undefined, true)
        ]),
        _: 3
      })
    ])
  ]))
}